
export interface VehicleModel {
  id: string;
  name: string;
  type: 'electrique' | 'hybride_rechargeable' | 'hybride';
  range?: number;
  batteryCapacity?: number;
}

export interface VehicleBrand {
  id: string;
  name: string;
  models: VehicleModel[];
}

export const vehicleBrands: VehicleBrand[] = [
  {
    id: 'tesla',
    name: 'Tesla',
    models: [
      { id: 'model-3', name: 'Model 3', type: 'electrique', range: 547, batteryCapacity: 82 },
      { id: 'model-y', name: 'Model Y', type: 'electrique', range: 533, batteryCapacity: 75 },
      { id: 'model-s', name: 'Model S', type: 'electrique', range: 652, batteryCapacity: 100 },
      { id: 'model-x', name: 'Model X', type: 'electrique', range: 560, batteryCapacity: 100 },
      { id: 'cybertruck', name: 'Cybertruck', type: 'electrique', range: 547, batteryCapacity: 123 }
    ]
  },
  {
    id: 'renault',
    name: 'Renault',
    models: [
      { id: 'zoe', name: 'Zoe', type: 'electrique', range: 395, batteryCapacity: 52 },
      { id: 'megane-e-tech', name: 'Megane E-Tech', type: 'electrique', range: 470, batteryCapacity: 60 },
      { id: 'twingo-electric', name: 'Twingo Electric', type: 'electrique', range: 190, batteryCapacity: 22 },
      { id: 'kangoo-electric', name: 'Kangoo Electric', type: 'electrique', range: 265, batteryCapacity: 45 },
      { id: 'captur-hybride', name: 'Captur Hybride', type: 'hybride_rechargeable', range: 65, batteryCapacity: 9.8 },
      { id: 'clio-hybride', name: 'Clio Hybride', type: 'hybride' },
      { id: 'arkana-hybride', name: 'Arkana Hybride', type: 'hybride' }
    ]
  },
  {
    id: 'peugeot',
    name: 'Peugeot',
    models: [
      { id: 'e-208', name: 'e-208', type: 'electrique', range: 400, batteryCapacity: 51 },
      { id: 'e-2008', name: 'e-2008', type: 'electrique', range: 406, batteryCapacity: 54 },
      { id: 'e-308', name: 'e-308', type: 'electrique', range: 413, batteryCapacity: 54 },
      { id: 'e-3008', name: 'e-3008', type: 'electrique', range: 527, batteryCapacity: 73 },
      { id: 'e-5008', name: 'e-5008', type: 'electrique', range: 500, batteryCapacity: 73 },
      { id: '3008-hybride', name: '3008 Hybride', type: 'hybride_rechargeable', range: 59, batteryCapacity: 13.2 },
      { id: '508-hybride', name: '508 Hybride', type: 'hybride_rechargeable', range: 58, batteryCapacity: 11.5 }
    ]
  },
  {
    id: 'citroen',
    name: 'Citroën',
    models: [
      { id: 'e-c4', name: 'ë-C4', type: 'electrique', range: 357, batteryCapacity: 50 },
      { id: 'e-c4-x', name: 'ë-C4 X', type: 'electrique', range: 360, batteryCapacity: 50 },
      { id: 'e-berlingo', name: 'ë-Berlingo', type: 'electrique', range: 280, batteryCapacity: 50 },
      { id: 'e-spacetourer', name: 'ë-SpaceTourer', type: 'electrique', range: 230, batteryCapacity: 50 },
      { id: 'c5-aircross-hybride', name: 'C5 Aircross Hybride', type: 'hybride_rechargeable', range: 55, batteryCapacity: 13.2 }
    ]
  },
  {
    id: 'audi',
    name: 'Audi',
    models: [
      { id: 'q4-e-tron', name: 'Q4 e-tron', type: 'electrique', range: 528, batteryCapacity: 82 },
      { id: 'q8-e-tron', name: 'Q8 e-tron', type: 'electrique', range: 600, batteryCapacity: 114 },
      { id: 'e-tron-gt', name: 'e-tron GT', type: 'electrique', range: 488, batteryCapacity: 93 },
      { id: 'a3-hybride', name: 'A3 Hybride', type: 'hybride_rechargeable', range: 78, batteryCapacity: 13 },
      { id: 'q5-hybride', name: 'Q5 Hybride', type: 'hybride_rechargeable', range: 61, batteryCapacity: 14.1 }
    ]
  },
  {
    id: 'bmw',
    name: 'BMW',
    models: [
      { id: 'i4', name: 'i4', type: 'electrique', range: 590, batteryCapacity: 83.9 },
      { id: 'i7', name: 'i7', type: 'electrique', range: 625, batteryCapacity: 101.7 },
      { id: 'ix', name: 'iX', type: 'electrique', range: 630, batteryCapacity: 111.5 },
      { id: 'ix3', name: 'iX3', type: 'electrique', range: 460, batteryCapacity: 80 },
      { id: 'serie-3-hybride', name: 'Série 3 Hybride', type: 'hybride_rechargeable', range: 61, batteryCapacity: 12 },
      { id: 'serie-5-hybride', name: 'Série 5 Hybride', type: 'hybride_rechargeable', range: 89, batteryCapacity: 17.3 },
      { id: 'x5-hybride', name: 'X5 Hybride', type: 'hybride_rechargeable', range: 108, batteryCapacity: 24 }
    ]
  },
  {
    id: 'mercedes',
    name: 'Mercedes-Benz',
    models: [
      { id: 'eqa', name: 'EQA', type: 'electrique', range: 426, batteryCapacity: 66.5 },
      { id: 'eqb', name: 'EQB', type: 'electrique', range: 423, batteryCapacity: 66.5 },
      { id: 'eqc', name: 'EQC', type: 'electrique', range: 471, batteryCapacity: 80 },
      { id: 'eqe', name: 'EQE', type: 'electrique', range: 639, batteryCapacity: 90.6 },
      { id: 'eqs', name: 'EQS', type: 'electrique', range: 770, batteryCapacity: 107.8 },
      { id: 'classe-a-hybride', name: 'Classe A Hybride', type: 'hybride_rechargeable', range: 77, batteryCapacity: 15.6 },
      { id: 'classe-c-hybride', name: 'Classe C Hybride', type: 'hybride_rechargeable', range: 113, batteryCapacity: 25.4 },
      { id: 'gle-hybride', name: 'GLE Hybride', type: 'hybride_rechargeable', range: 107, batteryCapacity: 31.2 }
    ]
  },
  {
    id: 'volkswagen',
    name: 'Volkswagen',
    models: [
      { id: 'id3', name: 'ID.3', type: 'electrique', range: 426, batteryCapacity: 58 },
      { id: 'id4', name: 'ID.4', type: 'electrique', range: 520, batteryCapacity: 77 },
      { id: 'id5', name: 'ID.5', type: 'electrique', range: 520, batteryCapacity: 77 },
      { id: 'id7', name: 'ID.7', type: 'electrique', range: 700, batteryCapacity: 86 },
      { id: 'id-buzz', name: 'ID. Buzz', type: 'electrique', range: 423, batteryCapacity: 82 },
      { id: 'golf-hybride', name: 'Golf Hybride', type: 'hybride_rechargeable', range: 80, batteryCapacity: 13 },
      { id: 'tiguan-hybride', name: 'Tiguan Hybride', type: 'hybride_rechargeable', range: 50, batteryCapacity: 10.4 },
      { id: 'passat-hybride', name: 'Passat Hybride', type: 'hybride_rechargeable', range: 100, batteryCapacity: 19.7 }
    ]
  },
  {
    id: 'hyundai',
    name: 'Hyundai',
    models: [
      { id: 'kona-electric', name: 'Kona Electric', type: 'electrique', range: 484, batteryCapacity: 64.8 },
      { id: 'ioniq-5', name: 'Ioniq 5', type: 'electrique', range: 507, batteryCapacity: 77.4 },
      { id: 'ioniq-6', name: 'Ioniq 6', type: 'electrique', range: 614, batteryCapacity: 77.4 },
      { id: 'tucson-hybride', name: 'Tucson Hybride', type: 'hybride_rechargeable', range: 65, batteryCapacity: 13.8 },
      { id: 'santa-fe-hybride', name: 'Santa Fe Hybride', type: 'hybride_rechargeable', range: 62, batteryCapacity: 13.8 }
    ]
  },
  {
    id: 'kia',
    name: 'Kia',
    models: [
      { id: 'e-niro', name: 'e-Niro', type: 'electrique', range: 463, batteryCapacity: 64.8 },
      { id: 'ev6', name: 'EV6', type: 'electrique', range: 528, batteryCapacity: 77.4 },
      { id: 'ev9', name: 'EV9', type: 'electrique', range: 541, batteryCapacity: 99.8 },
      { id: 'soul-ev', name: 'Soul EV', type: 'electrique', range: 386, batteryCapacity: 64 },
      { id: 'sorento-hybride', name: 'Sorento Hybride', type: 'hybride_rechargeable', range: 65, batteryCapacity: 13.8 },
      { id: 'sportage-hybride', name: 'Sportage Hybride', type: 'hybride_rechargeable', range: 69, batteryCapacity: 13.8 }
    ]
  },
  {
    id: 'nissan',
    name: 'Nissan',
    models: [
      { id: 'leaf', name: 'Leaf', type: 'electrique', range: 385, batteryCapacity: 59 },
      { id: 'ariya', name: 'Ariya', type: 'electrique', range: 533, batteryCapacity: 87 },
      { id: 'qashqai-hybride', name: 'Qashqai Hybride', type: 'hybride' },
      { id: 'x-trail-hybride', name: 'X-Trail Hybride', type: 'hybride_rechargeable', range: 72, batteryCapacity: 13.8 }
    ]
  },
  {
    id: 'ford',
    name: 'Ford',
    models: [
      { id: 'mustang-mach-e', name: 'Mustang Mach-E', type: 'electrique', range: 600, batteryCapacity: 91 },
      { id: 'explorer-electric', name: 'Explorer Electric', type: 'electrique', range: 500, batteryCapacity: 77 },
      { id: 'kuga-hybride', name: 'Kuga Hybride', type: 'hybride_rechargeable', range: 65, batteryCapacity: 14.4 },
      { id: 'escape-hybride', name: 'Escape Hybride', type: 'hybride_rechargeable', range: 60, batteryCapacity: 14.4 }
    ]
  },
  {
    id: 'opel',
    name: 'Opel',
    models: [
      { id: 'corsa-e', name: 'Corsa-e', type: 'electrique', range: 405, batteryCapacity: 50 },
      { id: 'mokka-e', name: 'Mokka-e', type: 'electrique', range: 405, batteryCapacity: 50 },
      { id: 'astra-hybride', name: 'Astra Hybride', type: 'hybride_rechargeable', range: 74, batteryCapacity: 12.4 },
      { id: 'grandland-hybride', name: 'Grandland Hybride', type: 'hybride_rechargeable', range: 65, batteryCapacity: 13.2 }
    ]
  },
  {
    id: 'ds',
    name: 'DS Automobiles',
    models: [
      { id: 'ds3-crossback-e-tense', name: 'DS 3 Crossback E-Tense', type: 'electrique', range: 402, batteryCapacity: 50 },
      { id: 'ds4-e-tense', name: 'DS 4 E-Tense', type: 'hybride_rechargeable', range: 58, batteryCapacity: 12.4 },
      { id: 'ds7-e-tense', name: 'DS 7 E-Tense', type: 'hybride_rechargeable', range: 65, batteryCapacity: 14.2 },
      { id: 'ds9-e-tense', name: 'DS 9 E-Tense', type: 'hybride_rechargeable', range: 58, batteryCapacity: 11.9 }
    ]
  },
  {
    id: 'volvo',
    name: 'Volvo',
    models: [
      { id: 'ex30', name: 'EX30', type: 'electrique', range: 480, batteryCapacity: 69 },
      { id: 'ex40', name: 'EX40', type: 'electrique', range: 533, batteryCapacity: 82 },
      { id: 'ex90', name: 'EX90', type: 'electrique', range: 600, batteryCapacity: 111 },
      { id: 'xc40-recharge', name: 'XC40 Recharge', type: 'electrique', range: 510, batteryCapacity: 82 },
      { id: 'xc60-hybride', name: 'XC60 Hybride', type: 'hybride_rechargeable', range: 88, batteryCapacity: 18.8 },
      { id: 'xc90-hybride', name: 'XC90 Hybride', type: 'hybride_rechargeable', range: 77, batteryCapacity: 18.8 },
      { id: 's60-hybride', name: 'S60 Hybride', type: 'hybride_rechargeable', range: 93, batteryCapacity: 18.8 }
    ]
  },
  {
    id: 'polestar',
    name: 'Polestar',
    models: [
      { id: 'polestar-2', name: 'Polestar 2', type: 'electrique', range: 654, batteryCapacity: 82 },
      { id: 'polestar-3', name: 'Polestar 3', type: 'electrique', range: 628, batteryCapacity: 111 },
      { id: 'polestar-4', name: 'Polestar 4', type: 'electrique', range: 560, batteryCapacity: 102 }
    ]
  },
  {
    id: 'fiat',
    name: 'Fiat',
    models: [
      { id: '500-electric', name: '500 Electric', type: 'electrique', range: 320, batteryCapacity: 42 },
      { id: '600-electric', name: '600 Electric', type: 'electrique', range: 400, batteryCapacity: 54 },
      { id: 'panda-hybride', name: 'Panda Hybride', type: 'hybride' }
    ]
  },
  {
    id: 'cupra',
    name: 'Cupra',
    models: [
      { id: 'born', name: 'Born', type: 'electrique', range: 550, batteryCapacity: 77 },
      { id: 'tavascan', name: 'Tavascan', type: 'electrique', range: 550, batteryCapacity: 77 },
      { id: 'leon-hybride', name: 'Leon Hybride', type: 'hybride_rechargeable', range: 60, batteryCapacity: 13 }
    ]
  },
  {
    id: 'skoda',
    name: 'Skoda',
    models: [
      { id: 'enyaq', name: 'Enyaq', type: 'electrique', range: 560, batteryCapacity: 82 },
      { id: 'enyaq-coupe', name: 'Enyaq Coupé', type: 'electrique', range: 570, batteryCapacity: 82 },
      { id: 'superb-hybride', name: 'Superb Hybride', type: 'hybride_rechargeable', range: 100, batteryCapacity: 25.7 },
      { id: 'octavia-hybride', name: 'Octavia Hybride', type: 'hybride_rechargeable', range: 62, batteryCapacity: 13 }
    ]
  },
  {
    id: 'seat',
    name: 'SEAT',
    models: [
      { id: 'cupra-born', name: 'Cupra Born', type: 'electrique', range: 550, batteryCapacity: 77 }
    ]
  },
  {
    id: 'mazda',
    name: 'Mazda',
    models: [
      { id: 'mx-30', name: 'MX-30', type: 'electrique', range: 200, batteryCapacity: 35.5 },
      { id: 'cx-60-hybride', name: 'CX-60 Hybride', type: 'hybride_rechargeable', range: 63, batteryCapacity: 17.8 }
    ]
  },
  {
    id: 'toyota',
    name: 'Toyota',
    models: [
      { id: 'bZ4X', name: 'bZ4X', type: 'electrique', range: 500, batteryCapacity: 71.4 },
      { id: 'proace-verso-electric', name: 'Proace Verso Electric', type: 'electrique', range: 330, batteryCapacity: 75 },
      { id: 'prius-hybride', name: 'Prius Hybride', type: 'hybride_rechargeable', range: 86, batteryCapacity: 13.6 },
      { id: 'rav4-hybride', name: 'RAV4 Hybride', type: 'hybride_rechargeable', range: 75, batteryCapacity: 18.1 },
      { id: 'corolla-hybride', name: 'Corolla Hybride', type: 'hybride' },
      { id: 'c-hr-hybride', name: 'C-HR Hybride', type: 'hybride_rechargeable', range: 76, batteryCapacity: 13.6 },
      { id: 'yaris-hybride', name: 'Yaris Hybride', type: 'hybride' }
    ]
  },
  {
    id: 'lexus',
    name: 'Lexus',
    models: [
      { id: 'ux-300e', name: 'UX 300e', type: 'electrique', range: 450, batteryCapacity: 72.8 },
      { id: 'rz-450e', name: 'RZ 450e', type: 'electrique', range: 470, batteryCapacity: 71.4 },
      { id: 'nx-hybride', name: 'NX Hybride', type: 'hybride_rechargeable', range: 76, batteryCapacity: 18.1 },
      { id: 'rx-hybride', name: 'RX Hybride', type: 'hybride_rechargeable', range: 65, batteryCapacity: 18.1 }
    ]
  },
  {
    id: 'honda',
    name: 'Honda',
    models: [
      { id: 'e', name: 'Honda e', type: 'electrique', range: 220, batteryCapacity: 35.5 },
      { id: 'hr-v-hybride', name: 'HR-V Hybride', type: 'hybride' },
      { id: 'cr-v-hybride', name: 'CR-V Hybride', type: 'hybride_rechargeable', range: 82, batteryCapacity: 17.7 }
    ]
  },
  {
    id: 'jeep',
    name: 'Jeep',
    models: [
      { id: 'avenger-electric', name: 'Avenger Electric', type: 'electrique', range: 400, batteryCapacity: 54 },
      { id: 'compass-hybride', name: 'Compass Hybride', type: 'hybride_rechargeable', range: 49, batteryCapacity: 11.4 },
      { id: 'wrangler-hybride', name: 'Wrangler Hybride', type: 'hybride_rechargeable', range: 49, batteryCapacity: 17.3 }
    ]
  },
  {
    id: 'mg',
    name: 'MG',
    models: [
      { id: 'mg4', name: 'MG4', type: 'electrique', range: 450, batteryCapacity: 64 },
      { id: 'mg5', name: 'MG5', type: 'electrique', range: 400, batteryCapacity: 61 },
      { id: 'zs-electric', name: 'ZS Electric', type: 'electrique', range: 440, batteryCapacity: 72 }
    ]
  },
  {
    id: 'dacia',
    name: 'Dacia',
    models: [
      { id: 'spring', name: 'Spring', type: 'electrique', range: 230, batteryCapacity: 26.8 }
    ]
  },
  {
    id: 'smart',
    name: 'Smart',
    models: [
      { id: 'smart-1', name: 'Smart #1', type: 'electrique', range: 440, batteryCapacity: 66 },
      { id: 'smart-3', name: 'Smart #3', type: 'electrique', range: 455, batteryCapacity: 62 }
    ]
  },
  {
    id: 'lucid',
    name: 'Lucid',
    models: [
      { id: 'lucid-air', name: 'Lucid Air', type: 'electrique', range: 837, batteryCapacity: 118 }
    ]
  },
  {
    id: 'rivian',
    name: 'Rivian',
    models: [
      { id: 'r1t', name: 'R1T', type: 'electrique', range: 640, batteryCapacity: 135 },
      { id: 'r1s', name: 'R1S', type: 'electrique', range: 640, batteryCapacity: 135 }
    ]
  }
];
